export default "__VITE_ASSET__CW_9Zr6I__"